import React, { useState } from 'react'
import Headline from './Headline'
import styles from '../stylesheets/Contact.module.scss'
import Fade from 'react-reveal/Fade'


const validEmailRegex =
  RegExp(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i);

const validateForm = (errors) => {
  let valid = true
  Object.values(errors).forEach(
    (val) => val.length > 0 && (valid = false)
  )
  return valid
}

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

const Contact = () => {
  const [state, setState] = useState({
    customername: '',
    email: '',
    message: '',
    errors: {
      customername: '',
      email: '',
      message: ''
    },
    displayMsg: false,
    mailSent: false
  })

  const handleChange = (event) => {
    event.preventDefault()
    const { name, value } = event.target
    let errors = state.errors

    switch (name) {
      case 'customername':
        errors.customername =
          value.length < 2
            ? 'Name must be at least 2 characters long'
            : ''
        break
      case 'email':
        errors.email =
          validEmailRegex.test(value)
            ? ''
            : 'Invalid email address'
        break
      case 'message':
        errors.message =
          value.length < 3
            ? 'Message too short'
            : ''
        break;
      default:
    }

    setState({ ...state, errors, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // const { customername, email, message } = this.state

    if (!validateForm(state.errors)) {
      setState({
        ...state,
        displayMsg: true
      })
    } else {
      const form = e.target
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': form.getAttribute('name'),
          customername: state.customername,
          email: state.email,
          message: state.message
        }),
      })
        .then(() => setState({ ...state, mailSent: true }))
        .catch((error) => alert(error))
    }
  }

  const content = () => {
    const { errors } = state
    const { customername, email, message, mailSent, displayMsg } = state

    if (!state.mailSent) {
      return (
        <>
          <Fade delay={1000}>
            <div className={styles.tagline}>
              <p>Let's get in touch.</p>
            </div>
          </Fade>
          <Fade delay={500}>
            <form
              name="contact"
              method="post"
              // action="/thanks/"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
              className={styles.form}
            >
              <input type="hidden" name="form-name" value="contact" /> {/* Netlify form field */}
              <p hidden>
                <label>
                  Don’t fill this out: <input name="bot-field" onChange={handleChange} />
                </label>
              </p>
              <input type="hidden" name="form-name" value="contact" />
              <input
                className={((displayMsg && errors.customername) ? `${styles.errorBox}` : '')}
                type="text"
                placeholder="Name"
                name="customername"
                value={customername}
                onChange={(event) => handleChange(event)}
              />
              {displayMsg && <span className={styles.error}>{errors.customername}</span>}
              <input
                className={((displayMsg && errors.email) ? `${styles.errorBox}` : '')}
                type="text"
                placeholder="Email"
                name="email"
                value={email}
                onChange={(event) => handleChange(event)}
              />
              {displayMsg && <span className={styles.error}>{errors.email}</span>}
              <textarea
                className={((displayMsg && errors.message) ? `${styles.errorBox}` : '')}
                placeholder="Message"
                name="message"
                value={message}
                onChange={(event) => handleChange(event)}
              />
              {displayMsg && <span className={styles.error}>{errors.message}</span>}
              <button
                disabled={!customername || !email || !message}
              >SEND</button>
              {mailSent === true &&
                <div className={styles.confirmed}>
                  <p>Thrilled to hear from you! </p>
                  <p>I will get back to you shortly</p>
                </div>
              }
            </form>
          </Fade>
        </>
      )
    } else {
      return (
        <Fade>
          <div className={styles.thanksMsg}>
            <h2>Thanks for reaching out, {customername}!</h2>
            <p>I'll contact you shortly.</p>
          </div>
        </Fade>
      )
    }
  }

  return (
    <div className={`container ${styles.flex}`}>
      <Fade left>
        <Headline title="CONTACT"></Headline>
      </Fade>
      {content()}
    </div>
  )

}

export default Contact
